<div class="ps-details-wrapper">
  @if (!details()) {
    <div class="loading">
      <nz-spin nzSimple nzSize="large" nzTip="Ładowanie danych zestawu procedur..." />
    </div>
  } @else {
    @let procedureSet = details()!;
    <div class="ps-view">
      <nz-card class="profile-card" [nzBordered]="false">
        <div class="profile-header">
          <div class="profile-icon">
            <span nz-icon nzType="appstore" nzTheme="outline"></span>
          </div>
          <div class="profile-info">
            <h1 class="profile-name">{{ procedureSet.name || '-' }}</h1>
            <div class="profile-meta">
              <nz-tag nzColor="blue">
                <span nz-icon nzType="tag"></span>
                {{ typeLabel() }}
              </nz-tag>
              <nz-tag [nzColor]="visibilityColor()">
                <span
                  nz-icon
                  [nzType]="procedureSet.isHidden ? 'close-circle' : 'check-circle'"
                ></span>
                {{ visibilityLabel() }}
              </nz-tag>
              @if (procedureSet.id) {
                <span class="badge">
                  <span nz-icon nzType="number"></span>
                  {{ procedureSet.id }}
                </span>
              }
            </div>
            <p class="profile-desc">{{ procedureSet.description || 'Brak opisu zestawu.' }}</p>
          </div>
        </div>
      </nz-card>

      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="profile" nzTheme="outline" class="section-icon"></span>
          <span>Dane zestawu</span>
        </div>

        <div class="details-grid">
          <div class="detail-item">
            <span class="detail-label">Nazwa</span>
            <span class="detail-value">{{ procedureSet.name || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Typ</span>
            <span class="detail-value">{{ typeLabel() }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Liczba procedur</span>
            <span class="detail-value">{{ proceduresCount() }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Domyślny czas wykonania</span>
            <span class="detail-value">
              {{ procedureSet.defaultEtcInMinutes ?? '-' }}
              @if (procedureSet.defaultEtcInMinutes) {
                <span>min</span>
              }
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Widoczność</span>
            <span class="detail-value">{{ visibilityLabel() }}</span>
          </div>
        </div>
      </nz-card>

      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="unordered-list" nzTheme="outline" class="section-icon"></span>
          <span>Procedury w zestawie</span>
          <nz-tag nzColor="processing" style="margin-left: auto; font-weight: 500">
            {{ proceduresCount() }}
          </nz-tag>
        </div>

        <nz-list nzBordered>
          @for (procedure of procedureSet.medServices; track procedure.id) {
            <nz-list-item>
              <span>{{ procedure.name || '-' }}</span>
            </nz-list-item>
          } @empty {
            <nz-list-item>
              <span class="empty-label">Brak przypisanych procedur</span>
            </nz-list-item>
          }
        </nz-list>
      </nz-card>
    </div>

    <div class="button-footer-wrapper">
      <a nz-button nzType="default" routerLink="/procedure-sets">
        <span nz-icon nzType="arrow-left"></span>
        Wstecz
      </a>
    </div>
  }
</div>
